export { default } from './Medications';
